import { useEffect } from 'react'

const ActivitiesSection = () => {
  const activityImages = [
    '/img/about-us/IMG_0413-2.png',
    '/img/about-us/DSC01142-1.png',
    '/img/about-us/DSC07786-1.png',
    '/img/about-us/DSC00944-1.png',
  ]

  useEffect(() => {
    // Initialize seamless scroll animation for activities
    const initActivitiesScroll = () => {
      const wrapper = document.querySelector(
        '.scroll-wrapper-activities'
      ) as HTMLElement
      if (!wrapper) return

      const slides = wrapper.querySelectorAll('.image-slider-lg')
      if (slides.length === 0) return

      // Create container for animation
      const container = document.createElement('div')
      container.style.display = 'flex'
      container.style.transition = 'none'

      // Clone slides multiple times for seamless loop
      for (let i = 0; i < 3; i++) {
        slides.forEach((slide) => {
          const clonedSlide = slide.cloneNode(true) as HTMLElement
          container.appendChild(clonedSlide)
        })
      }

      // Replace wrapper content
      wrapper.innerHTML = ''
      wrapper.appendChild(container)

      // Animation variables
      let position = 0
      const slideWidth = window.innerWidth < 768 ? 280 : 508 // Responsive width
      const totalSlides = slides.length
      const resetPoint = slideWidth * totalSlides
      const speed = 0.5

      let isPaused = false

      const animate = () => {
        if (!isPaused) {
          position -= speed
          if (position <= -resetPoint) {
            position = 0
          }
          container.style.transform = `translateX(${position}px)`
        }
        requestAnimationFrame(animate)
      }

      animate()

      // Pause on hover
      wrapper.addEventListener('mouseenter', () => {
        isPaused = true
      })
      wrapper.addEventListener('mouseleave', () => {
        isPaused = false
      })
    }

    // Initialize with delay
    setTimeout(initActivitiesScroll, 200)
  }, [])

  return (
    <section className="flex flex-col items-center justify-center bg-white py-12 md:py-16">
      {/* Container with responsive padding */}
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        {/* Section Title */}
        <div className="mb-6 text-center md:mb-8">
          <h2 className="mb-4 font-['Poppins'] text-xl font-bold md:mb-6 md:text-2xl lg:text-3xl">
            <span className="text-[#d91f2e]"> Kegiatan</span>
            <span className="text-[#475467]"> Bersama Tim</span>
          </h2>

          <p className="mx-auto max-w-[923px] px-4 text-center font-['Poppins'] text-sm font-normal leading-5 text-[#475467] md:px-0 md:text-base md:leading-6">
            Di sela kesibukan membangun masa depan talenta Indonesia, kami
            meluangkan waktu untuk merayakan kebersamaan. Karena bagi kami, tim
            yang hebat bukan hanya bekerja bersama, tapi juga tertawa dan tumbuh
            bersama.
          </p>
        </div>
      </div>

      {/* Activities Photos Scrolling Section - Full width with no padding */}
      <div className="w-full overflow-hidden">
        <div className="scroll-wrapper-activities flex items-center overflow-hidden">
          {activityImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Team activity ${index + 1}`}
              className="image-slider-lg min-h-[167px] min-w-[250px] flex-shrink-0 rounded-lg object-cover pr-3 md:min-h-[325px] md:min-w-[488px] md:pr-4"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default ActivitiesSection
